import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BudgetFiscalYearContainerModel } from "../../../../../../models/aggregates/erp/financial/";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class BudgetFiscalYearService extends BaseApiTemplateService<BudgetFiscalYearContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-fiscal-years/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-fiscal-years/backoffice-ep";
    this.httpClient = http;
  }
}
